import { render } from "./MultipleProductRow.vue?vue&type=template&id=f4dcc9a0&lang=pug"
import script from "./MultipleProductRow.vue?vue&type=script&lang=js"
export * from "./MultipleProductRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__